import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';

/**
 * Firebase Web SDK config
 * 
 * These are PUBLIC identifiers, not secrets. Security comes from Firebase Security Rules.
 * 
 * Values are injected at build time by esbuild (see scripts/build.mjs):
 * - DEV build: Uses DEV Firebase project (sandbox)
 * - PROD build: Uses PROD Firebase project (production)
 * - Local: Falls back to DEV project values (defined in build.mjs)
 */
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// Log which Firebase project is being used (helpful for debugging)
if (import.meta.env.DEV) {
  console.log('Firebase project:', firebaseConfig.projectId);
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Firebase Analytics (only in browser environment)
export let analytics = null;
try {
  if (typeof window !== 'undefined') {
    analytics = getAnalytics(app);
  }
} catch (error) {
  console.warn('Firebase Analytics not available:', error);
}

// Initialize Firestore
export const db = getFirestore(app);

export default app; 